import { Stack, TextField } from '@mui/material';

import Form from 'components/Form';

import { IFormRegister } from '../type';

interface Props extends IFormRegister {
  disabled?: boolean;
  isTestMode?: boolean;
}

function Soapie({ register, disabled, isTestMode }: Props) {
  const handlePreventEvent = (e: React.ClipboardEvent | React.MouseEvent) => {
    if (isTestMode) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  return (
    <Stack spacing={2}>
      <Form.Item label="Субъектив өгөгдөл">
        <TextField
          fullWidth
          multiline
          minRows={2}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('subjective')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>

      <Form.Item label="Объектив өгөгдөл">
        <TextField
          fullWidth
          multiline
          minRows={2}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('objective')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>

      <Form.Item label="Үнэлгээ">
        <TextField
          fullWidth
          multiline
          minRows={2}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('assessment')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>

      <Form.Item label="Төлөвлөлт">
        <TextField
          fullWidth
          multiline
          minRows={2}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('planning')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>

      <Form.Item label="Хэрэгжүүлэлт">
        <TextField
          fullWidth
          multiline
          minRows={2}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('interventions')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>

      <Form.Item label="Дүгнэлт">
        <TextField
          fullWidth
          multiline
          minRows={2}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('evaluation')}
          onPaste={handlePreventEvent}
          onCopy={handlePreventEvent}
          onContextMenu={handlePreventEvent}
        />
      </Form.Item>
    </Stack>
  );
}

export default Soapie;
